<div>
  <p>{{"Your Mercedes me Charge account has been linked with ChargePoint. You are ready to start charging your Mercedes-Benz EQ vehicle at charging stations across the country." | T }}</p>
  <cp-signup-footer-controls [showBackButton]="false" [nextButtonText]="nextButton" (nextClicked)="navigateDriverPortal()"></cp-signup-footer-controls>
</div>
